import clsx from 'clsx'
import { ToolbarType, useLayout } from '../../core'
// import { Toolbar } from './Toolbar'
import { PageTitleWrapper } from './page-title'
import { ToolbarTimesheet } from './toolbars/ToolbarTimesheet'
import { ToolbarExpense } from './toolbars/ToolbarExpense'
import { useLocation } from 'react-router-dom';

const ToolbarWrapper = () => {
  const location = useLocation();
  const routeName = location.pathname.split('/').filter(Boolean)[0];
  const { config, classes } = useLayout()
  if (!config.app?.toolbar?.display) {
    return null
  }

  const isPageTitleVisible = showPageTitle(
    config.app?.toolbar?.layout,
    config.app?.pageTitle?.display
  )

  return (
    <div
      id='kt_app_toolbar'
      className={clsx('app-toolbar toolbarAllignment', classes.toolbar.join(' '), config?.app?.toolbar?.class)}
    // style={{ top: 50, backgroundColor: '#ffffff', boxShadow: '0 0px 4px rgba(0,0,0,.25) !important' }}
    >
      <div
        id='kt_app_toolbar_container'
        className={clsx(
          'app-container',
          classes.toolbarContainer.join(' '),
          config.app?.toolbar?.containerClass,
          config.app?.toolbar?.minimize?.enabled ? 'app-toolbar-minimize' : '',
          {
            'container-fluid': config.app?.toolbar?.container === 'fluid',
            'container-xxl': config.app?.toolbar?.container === 'fixed',
            // 'container-fluid': config.app?.toolbar?.container === 'fixed',
            // 'container-xxl': config.app?.toolbar?.container === 'fluid',
          }
        )}
      >
        {isPageTitleVisible && <PageTitleWrapper />}
        {routeName === 'timesheet' ? <ToolbarTimesheet /> : routeName === 'expenseentries' && <ToolbarExpense />}
        {/* <Toolbar /> */}
      </div>
    </div>
  )
}

const showPageTitle = (appToolbarLayout?: ToolbarType, appPageTitleDisplay?: boolean): boolean => {
  const viewsWithPageTitles = ['classic', 'reports', 'saas']
  if (!appToolbarLayout || !appPageTitleDisplay) {
    return false
  }

  return appPageTitleDisplay && viewsWithPageTitles.some((t) => t === appToolbarLayout)
}

export { ToolbarWrapper }